export default __webpack_public_path__ + "static/media/fontRoboto700_cyrillic.d010f1f3.woff2";